import { Directive, Inject, Input, OnInit } from 'angular-ts-decorators';

@Directive({
  selector: '[fadeOutOnBgChange]',
})
export class FadeOutOnBgChangeDirective implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$element'];

  @Input('@') public fadeOutOnBgChangeSrc?: string;
  @Input('@') public src?: string;

  constructor(@Inject('$element') private $element: JQLite) { }

  public ngOnInit(): void {
    const callback: MutationCallback = (mutationList: MutationRecord[]): void => {
      for (const mutation of mutationList) {
        const target: HTMLImageElement = mutation.target as HTMLImageElement;

        target.classList.remove('lazy-loaded');
        setTimeout((): void => {
          target.dataset.bg = this.fadeOutOnBgChangeSrc;
          (this.$element as any).lazyLoadXT();
          window.scrollTo(window.scrollX || window.pageXOffset, (window.scrollY || window.pageYOffset) - 1);
          window.scrollTo(window.scrollX || window.pageXOffset, (window.scrollY || window.pageYOffset) + 1);
        }, 250);
      }
    };

    const observer: MutationObserver = new MutationObserver(callback);
    observer.observe(this.$element[0], {
      attributeFilter: ['fade-out-on-bg-change-src'],
      attributes: true,
    } as MutationObserverInit);
  }
}
